import styled, { css } from 'styled-components';
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { ReactComponent as Monitor } from "assets/SidebarIcons/monitor.svg";

type props = {
  isNavBarExpanded?: boolean
}

export const Nav = styled.nav<props>`
  display: flex;
  flex-direction: column;
  background-color: var(--black-200);

  ${(props) => props.isNavBarExpanded ? css`
  width: 10vw;
  height: 100vh;
  ` : css`
  width: 100px;
  height: 100vh;
  `}
`

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100px;

  border-bottom: 1px solid #3d3d3d;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    height: 4vh;
  }

  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  padding: 0.9rem;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-bottom: 0.5rem;
`

export const LinksContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
`

type StyledLinkProps = {
  isSelected?: boolean;
}

export const StyledLink = styled(Link)<StyledLinkProps>`
  width: 100%;
  padding: 0.6rem;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  border-width: 0px 4px 0px 4px;
  border-style: solid;
  border-color: transparent;

  svg {
    path {
      stroke: var(--grey-100);
    }

    pointer-events: none;
  }

  ${props => props.isSelected && css`
    border-right-color: var(--primary);

    svg {
      path {
        stroke-width: 2px;
      }
    }
  `}

  @media screen and (max-width: 1400px) {
    padding: 0.4rem;
    margin-bottom: 0.1rem;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`

export const NavLink = styled.a`
  width: 100%;
  padding: 0.6rem;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      stroke: var(--grey-100);
    }
  }

  img {
    pointer-events: none;

  }

  &.active {
    svg {
      path {
        stroke: var(--primary);
      }
    }
  }

  @media screen and (max-width: 1400px) {
    padding: 0.4rem;
    margin-bottom: 0rem;

    img {
      width: 20px;
      height: 20px;
    }
  }

  @media (min-width: 1920px) {
    img {
      height: 26px;
    }
  }
`
export const StyledReactTooltip = styled(ReactTooltip)`
  color: var(--white);
  font-family: DM Sans;
  font-size: 1rem !important;
  font-weight: 500;
  width: auto;
  opacity: 1 !important;
  margin-left: -20px !important;
`

export const Links = styled.div<props>`
  pointer-events: none;
  
  ${(props) =>
    props.isNavBarExpanded
      && css`
          width: 100%;
        `
  }

  pointer-events: none;
`

type propsSideBar = {
  isSelected?: boolean;
}

export const SideBarIconSelected = styled.div<propsSideBar>`
  svg {
    width: 24px;
    height: 24px;
  }

  ${(props) =>
    props.isSelected
      && css`
      svg {
        path {
          stroke: var(--primary) !important;
        }
      }`
    }
  pointer-events: none;

  @media (max-width: 1440px) {
    svg {
      width: 1.15rem;
      height: 1.15rem;
    }
  }
`

export const StyledMonitorIcon = styled(Monitor)<propsSideBar>`
  ${(props) => 
    props.isSelected && css`
    fill: var(--primary);
    `
  }
`